export default __webpack_public_path__ + "static/media/rent-benefit-img1.95b02bd0.jpg";